import React from 'react';
import { SectionHeading } from './SectionHeading';
import { TestimonialCard } from './TestimonialCard';
import { finalTestimonials } from '../data/salesData';
export function TestimonialsSection() {
  return <section className="border-b border-[var(--olive)]/30 py-16 sm:py-20" data-id="element-212" data-mp="1mz92pd4ps6ew">
      <div className="mx-auto max-w-6xl px-4" data-id="element-213" data-mp="1r0uc2oi1i2kc">
        <SectionHeading eyebrow="❤️ Comunidad" data-id="element-214" data-mp="1qzsxia1texxv">
          Más profes que ya lo tienen
        </SectionHeading>

        <div className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-215" data-mp="1d47fwnxwvgfh">
          {finalTestimonials.map(t => <TestimonialCard key={t.name} testimonial={t} data-id="element-216" data-mp="1hyl4o7i2ipb6" />)}
        </div>
      </div>
    </section>;
}